import { useQuery } from '@tanstack/react-query';
import studioApiClient from '../api/studio';

export const STUDIO_FAQ_QUERY_KEY = 'studio-faq';

const THIRTY_MINUTES = 30 * 60 * 1000;

const useStudioFaq = () => {
  return useQuery({
    queryKey: [STUDIO_FAQ_QUERY_KEY],
    queryFn: () => studioApiClient.getFaq(),
    staleTime: THIRTY_MINUTES,
  });
};

export default useStudioFaq;
